import { render, staticRenderFns } from "./Tictactoe.vue?vue&type=template&id=926bb614&"
import script from "./Tictactoe.vue?vue&type=script&lang=js&"
export * from "./Tictactoe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports